<div class="check-lists-local" [formGroup]="form">
  <app-select
    formControlName="hdChecklist"
    name="HDCheckList"
    class="check-lists-local__control"
    textKey="name"
    [initBy]="selectedHDChecklist"
    (callback)="handleChangeHDChecklist($event)"
    [items]="checklists"
    [nullChoice]="true"
  >
  </app-select>

  <button type="button" class="button check-lists-local__button" (click)="openCreateLocalChecklist()">+</button>

  <ui-multicombobox
    class="check-lists__control"
    defaultText="Тип заявки из HD"
    textKey="name"
    name="localHDTicketType"
    (callback)="handleChangeTicketType($event)"
    [items]="hdTicketTypes | func: cloneDeep"
    [initBy]="selectedHDTicketTypes"
    [nullChoice]="false"
    [sortByFn]="sortBySelected"
    [isDisabled]="!selectedHDChecklist"
  >
  </ui-multicombobox>
</div>
